
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "symbol-view",
  props: {
    text: {
      type: String,
      default: "",
    },
    img: String,
    size: {
      type: String as () => "small" | "medium" | "large",
      default: "medium",
    },
    customClass: String,
  },
  setup(props) {
    const sizeCalc = computed(() => {
      return props.text.length > 5 ? "2" : "3";
    });
    return { sizeCalc };
  },
});
